export const socialLinksContent = {
  linkedin: 'https://ve.linkedin.com/company/grupo-venemergencia',
  instagram: 'https://www.instagram.com/venemergencia/',
  twitter: 'https://twitter.com/venemergencia',
  facebook: 'https://es-la.facebook.com/venemergencia/'
}
